/* eslint-disable */
// Helpers partagés par les vues du dossier menu.

// « 2 500 FCFA » - espace insécable fine avant l'unité, séparateur de milliers FR.
export function fmt(n) {
    return (Math.round(Number(n)) || 0).toLocaleString("fr-FR") + " FCFA";
}

export function slug(s) {
    return sansAccent(s).replace(/[^a-z0-9]+/g, "-");
}

// Recherche tolérante : « attieke » doit trouver « Attiéké ». Au restaurant,
// personne ne tape les accents sur un clavier de téléphone.
export function sansAccent(s) {
    return String(s || "")
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .toLowerCase();
}

// ── Modèle article ────────────────────────────────────────────────────────────
// Un plat peut avoir PLUSIEURS TARIFS (portions) et PLUSIEURS ACCOMPAGNEMENTS.
//   tarifs: [{ pid, libelle, pu, prixpromo, defaut }]
//   accompagnement: [{ pid, name, supplement }]
//   multiaccomp: 0 | 1   → 1 = le client peut en cumuler plusieurs
//   platdujour: 0 | 1
// Repli : si `tarifs` est absent, on fabrique un tarif unique depuis pu/prixpromo,
// pour que la vue continue de fonctionner avec l'ancien format d'article.

export function tarifs(item) {
    if (Array.isArray(item.tarifs) && item.tarifs.length) return item.tarifs;
    return [{
        pid: item.pid + "-std",
        libelle: item.unite || "Portion",
        pu: Number(item.pu) || 0,
        prixpromo: Number(item.prixpromo) || 0,
        defaut: true,
    }];
}

export function tarifDefaut(item) {
    const list = tarifs(item);
    return list.find(t => t.defaut) || list[0];
}

export function enPromo(tarif) {
    return Number(tarif.prixpromo) > 0 && Number(tarif.prixpromo) < Number(tarif.pu);
}

export function prixTarif(tarif) {
    return enPromo(tarif) ? Number(tarif.prixpromo) : Number(tarif.pu);
}

export function remise(tarif) {
    if (!enPromo(tarif)) return 0;
    return Math.round((1 - Number(tarif.prixpromo) / Number(tarif.pu)) * 100);
}

// Prix d'appel affiché sur la carte : le moins cher des tarifs.
export function prixMini(item) {
    return Math.min.apply(null, tarifs(item).map(prixTarif));
}

export function plusieursTarifs(item) {
    return tarifs(item).length > 1;
}

// La meilleure remise parmi les tarifs, pour l'étiquette « -17% ».
export function meilleureRemise(item) {
    return Math.max.apply(null, tarifs(item).map(remise));
}

export function platDuJour(item) {
    return Number(item.platdujour || item.plat_du_jour || 0) > 0;
}

export function disponible(item) {
    return parseFloat(item.rstck) > 0;
}

export function multiAccomp(item) {
    return Number(item.multiaccomp || 0) > 0;
}
